import React from 'react';
import { Box3, Vector3 } from 'three';

import { Point3D } from '@paragon/contract-library';
import { newVector3 } from '@paragon/three-shared';

import { useAppDispatch } from '../../components/hooks';
import { openFullTransformMenu, openSnappingMenu } from '../../store/slices/panelDataSlice';
import { BoundingHitbox } from '../util/BoundingHitBox';
import { R3FSvgVisual } from '../util/R3FSvgVisual';

interface Props {
  position: Point3D;
  size?: number;
  settings: 'FullTransform' | 'Snapping';
}

export const NudgeSettingsButton = ({ position, size = 1, settings }: Props) => {
  const dispatch = useAppDispatch();
  const onClick = () => dispatch(settings === 'FullTransform' ? openFullTransformMenu() : openSnappingMenu());

  const scaledSize = size * 0.42;

  return (
    <group position={newVector3(position)}>
      <R3FSvgVisual iconName="mui-settings-icon" rotation={0} size={size} />
      <BoundingHitbox
        box3={new Box3(new Vector3(-scaledSize, -scaledSize, -0.05), new Vector3(scaledSize, scaledSize, 0.05))}
        mouseDown={onClick}
      />
    </group>
  );
};
